import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, ViewChild } from '@angular/core';
import { HubioTableComponent, HubioTableOptions } from '@hubio/hubio-common-components';
import { AgentRecord } from '../../models/dashboard.model';
import { DashboardService } from '../../services/dashboard.service';
import { agentsTableConfig } from '../../configs/agents-table.config';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-agents-table',
  templateUrl: './agents-table.component.html',
  styleUrls: ['./agents-table.component.scss']
})
export class AgentsTableComponent implements OnInit {

  @ViewChild('table', { static: true }) public table: HubioTableComponent;
  @Output() public rowClick: EventEmitter<AgentRecord> = new EventEmitter();
  @Input() public dataObservable: Observable<AgentRecord[]>;
  @Input() public data: AgentRecord[];

  public tableOptions: HubioTableOptions
  private tableConfig;

  constructor(
    private dashboardService: DashboardService,
  ) { }

  ngOnInit(): void {
    this.initComponent();
   }

   ngAfterViewInit(): void {
    this.setData();
  }

  private initComponent() {
    this.initMetadata();
    this.initTableOptions();
  }

  initMetadata() {
    this.tableConfig = agentsTableConfig.tableDefinition;
  }

  private initTableOptions() {
    this.tableOptions = {
      columns: this.tableConfig.columns,
      tooltip: this.tableConfig.tooltip,
      paginator: {
        paginate: false
      },
      cache: {
        cache: false
      }
    };
  }

  setData() {
    this.table.setData(this.data, 0);
    this.dataObservable.subscribe((data: AgentRecord[]) => {
      this.table.setData(data, 0);
    })
  }

  handleRowClick(broker: AgentRecord) {
    this.rowClick.emit(broker);
  }

}
